/**
 * Global Functionality
 * The logic in this is intended to ONLY contain any functionality
 * that is required on every page load.
 *
 * NOTE: Please do not include any page-specific logic here.
 **/

import Logger from "./logger";
import VimeoPlayer from "./vimeo-player";
import SelectStore from "./select-store";
import SelectStoreRestrictPopup from "./select-store-cp-restrict-popup";
import LocationStorage from "./location-storage";
import Sidecart from "./sidecart";
import ChatBot from "./chatbot";

export default function () {
	const NAME = "Global";
	Logger.info(`${NAME} > loading`);

	// Vars
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
	const navigationToggle = document.getElementById("navigationToggle");
	const navigationItems = document.getElementById("navigationItems");
	const navigationToggleTop = document.querySelector(
		".navigation__toggle--top"
	);
	const navigationToggleMiddle = document.querySelector(
		".navigation__toggle--middle"
	);
	const navigationToggleBottom = document.querySelector(
		".navigation__toggle--bottom"
	);
	const navigationSearchIcon = document.querySelector(
		".navigation__search-icon--image"
	);
	const searchForm = document.querySelector(".navigation__search-form");
	const heroVideoIdEl = document.querySelector(".global-hero [data-vimeo-ids]");
	const videoIdFiftyEls = document.querySelectorAll("[data-vimeo-ids-fifty]");
	// Logic
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
	const heroPlayer = () => {
		if (heroVideoIdEl && heroVideoIdEl.dataset.videoDesktop) {
			let launchBtn = document.querySelector(".global-hero .video-btn");
			if (!launchBtn)
				launchBtn = document.querySelector(
					".global-hero .theme-button--icon__play"
				);
			VimeoPlayer(
				{
					name: "Hero",
					mobile: heroVideoIdEl,
					desktop: heroVideoIdEl,
					launchBtn: launchBtn,
					preventBodyScroll: true,
				},
				{
					autoplay: true,
					loop: false,
					byline: false,
					controls: true,
					title: false,
					responsive: true,
				}
			);
		}
	};

	const fiftyFiftyPlayers = () => {
		if (videoIdFiftyEls)
			videoIdFiftyEls.forEach((el, i) => {
				if (el.dataset.videoDesktop) {
					VimeoPlayer(
						{
							name: `50-50 Video ${i}`,
							desktop: el,
							launchBtn: el.parentNode,
							container: el.parentNode.nextSibling,
							hideElement: el.parentNode,
						},
						{
							autoplay: true,
							loop: false,
							byline: false,
							controls: true,
							title: false,
							responsive: true,
							playsinline: true,
						}
					);
				}
			});
	};

	const fiftyFiftyShopifyPlayers = () => {
		const playBtns = document.querySelectorAll('[data-shopify-hosted-video][data-has-video=true] .video-btn-wrap');
		if (playBtns) {
			playBtns.forEach((btn, i) => {
				const video = btn.previousElementSibling;
				video.addEventListener('playing', () => btn.dataset.playing = true);
				video.addEventListener('pause', () => btn.dataset.playing = false);
				video.addEventListener('ended', () => {btn.dataset.playing = false; video.load();});
				btn.addEventListener('click', () => {
					if (video.paused) {
						video.play();
					} else {
						video.pause();
					}
				})
			})
		}
	}

	const cpPagePaths = [
		'/pages/muse-s-gen2',
		'/pages/muse-s-gen2-offer',
		'/pages/muse-s-muse2',
		'/pages/training-wheels-for-meditation'
	];

	/**
	 * init --- Initialization block
	 */
	function init() {
		Logger.info(`${NAME} > init`);
		if (!cpPagePaths.includes(window.location.pathname)) {
			ChatBot();
			Sidecart();
			SelectStore();
			SelectStoreRestrictPopup();
			LocationStorage();
			heroPlayer();
			fiftyFiftyPlayers();
			fiftyFiftyShopifyPlayers();

			navigationToggle.addEventListener("click", () => {
				navigationItems.classList.toggle("navigation__items--show");
				navigationToggleTop.classList.toggle("navigation__toggle--top-close");
				navigationToggleMiddle.classList.toggle(
					"navigation__toggle--middle-close"
				);
				navigationToggleBottom.classList.toggle(
					"navigation__toggle--bottom-close"
				);
			});
	
			const closeNavigationMobileOnResize = () => {
				if (window.innerWidth >= 960) {
					navigationItems.classList.remove("navigation__items--show");
					navigationToggleTop.classList.remove("navigation__toggle--top-close");
					navigationToggleMiddle.classList.remove(
						"navigation__toggle--middle-close"
					);
					navigationToggleBottom.classList.remove(
						"navigation__toggle--bottom-close"
					);
				}
			};
	
			navigationSearchIcon.addEventListener("click", () => {
				searchForm.classList.toggle("navigation__search-form--hide");
			});
	
			window.onresize = closeNavigationMobileOnResize;
		}
	}

	// Do not edit below this line...
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
	Logger.info(`${NAME} > loaded`);

	init();
}
